import React, { useState, useEffect } from "react";
import useWindowDimensions from "../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { BaseButtons, TextInputField } from "../../../common-components";
import { colors } from "../../../../themes/Colors";
import { CreateProductModal } from "./components";
import CatalogueListItem from "./components/catalogue-list-item/CatalogueListItem";

const Catalogue = ({
  companyInformation,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const { width, height } = useWindowDimensions();
  const [searchText, setSearchtext] = useState("");
  const [search, setSearch] = useState("");

  const [createPostModal, setCreatePostModal] = useState(false);

  const [productsArray, setProductsArray] = useState(null);

  const [selectedProduct, setSelectedProduct] = useState(null);

  const getProducts = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/catalogue/getProducts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            bussinessId: companyInformation._id,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setProductsArray(respnseData.products);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (companyInformation) {
      getProducts();
    }
  }, [refresh, companyInformation]);

  return (
    <div
      style={{
        flex: 1,
        // borderStyle: "solid",
        maxHeight: height - 70,
        height: height - 70,
        minHeight: height - 70,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* action header */}
      <div
        style={{
          width: "100%",
          //   borderStyle: "solid",
          //   borderWidth: 1,
          minHeight: 60,
          display: "flex",
          alignItems: "center",
          //   backgroundColor: colors.white,
          position: "relative",
          zIndex: 200,
        }}
      >
        <div
          style={{
            backgroundColor: colors.white,
            borderRadius: 4,
            display: "flex",
            marginLeft: 10,
          }}
        >
          <TextInputField
            mini={true}
            marginTop={-5}
            // invert={true}
            placeholder={"type here to search"}
            height={20}
            value={searchText}
            onChange={(e) => setSearchtext(e.target.value)}
          />
        </div>
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"CLEAR"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          onClick={() => {
            setSearchtext("");
            setSearch("");
          }}
        />{" "}
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"SEARCH"}
          borderRadius={8}
          backgroundColor={colors.primaryBlue}
          onClick={() => setSearch(searchText)}
        />
        <div style={{ marginLeft: 20, fontWeight: "bold" }}>
          PRODUCT CATALOGUE
        </div>
        <div style={{ marginLeft: 10, position: "relative" }}>
          {/* <BaseButtons
            label={"FILTER"}
            borderRadius={8}
            backgroundColor={colors.primaryBlue}
            onClick={() => setFilterPopUp(filterPopUp ? false : true)}
          /> */}
          {/* {filterPopUp ? (
            <div
              style={{
                position: "absolute",
                backgroundColor: colors.white,
                padding: 10,
                borderRadius: 4,
                bottom: -325,
                minHeight: 300,
                width: 300,
                left: 10,
                WebkitBoxShadow: "0px 0px 7px 2px #00000030",
              }}
            >
              <div
                style={{ marginTop: 10, marginLeft: 10, fontWeight: "bold" }}
              >
                FILTER OPTIONS
              </div>
              <div
                style={{
                  marginTop: 4,
                  marginLeft: 10,
                  fontWeight: "bold",
                  fontSize: 12,
                  opacity: 0.7,
                }}
              >
                please select the options you would like to be able to view
              </div>
              <CheckInput
                label={"ALL"}
                onClick={() => setMainfilterChoice("all")}
                selected={mainfilterChoice === "all" ? true : false}
              />
              <CheckInput
                label={"PROVINCES"}
                onClick={() => setMainfilterChoice("province")}
                selected={mainfilterChoice === "province" ? true : false}
              />
              <CheckInput
                label={"VEHICLE MAKE"}
                onClick={() => setMainfilterChoice("make")}
                selected={mainfilterChoice === "make" ? true : false}
              />
              <CheckInput
                label={"CUSTOME REQUEST"}
                onClick={() => setMainfilterChoice("custom")}
                selected={mainfilterChoice === "custom" ? true : false}
              />

              {mainfilterChoice === "all" ? (
                <div
                  style={{
                    marginTop: 60,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  "No extra options currently availible"
                </div>
              ) : null}
              {mainfilterChoice === "province" ? (
                <div
                  style={{
                    marginTop: 10,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <div style={{ marginBottom: 4, fontSize: 12 }}>
                    List of provinces
                  </div>
                  <div style={{ display: "flex" }}>
                    <CheckInput
                      label={"EC"}
                      onClick={() => setEc(ec ? false : true)}
                      selected={ec}
                    />
                    <CheckInput
                      label={"FS"}
                      onClick={() => setFs(fs ? false : true)}
                      selected={fs}
                    />
                    <CheckInput
                      label={"GP"}
                      onClick={() => setGp(gp ? false : true)}
                      selected={gp}
                    />
                  </div>
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <CheckInput
                      label={"KN"}
                      onClick={() => setKn(ec ? false : true)}
                      selected={kn}
                    />
                    <CheckInput
                      label={"LP"}
                      onClick={() => setLp(fs ? false : true)}
                      selected={lp}
                    />
                    <CheckInput
                      label={"MP"}
                      onClick={() => setMp(mp ? false : true)}
                      selected={mp}
                    />
                  </div>
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <CheckInput
                      label={"NC"}
                      onClick={() => setNc(ec ? false : true)}
                      selected={nc}
                    />
                    <CheckInput
                      label={"NW"}
                      onClick={() => setNw(fs ? false : true)}
                      selected={nw}
                    />
                    <CheckInput
                      label={"WC"}
                      onClick={() => setWc(gp ? false : true)}
                      selected={wc}
                    />
                  </div>
                </div>
              ) : null}
              {mainfilterChoice === "make" ? (
                <div
                  style={{
                    marginTop: 40,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <TextInputField mini={true} labelTitle={"Vehicle Make"} />
                </div>
              ) : null}
              {mainfilterChoice === "custom" ? (
                <div
                  style={{
                    marginTop: 10,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <TextInputFieldArea
                    height={80}
                    size={"80%"}
                    mini={true}
                    labelTitle={"Custome search"}
                  />
                </div>
              ) : null}
            </div>
          ) : null} */}
        </div>
        <div style={{ flex: 1 }} />
        <BaseButtons
          label={"REFRESH"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          onClick={() => setRefresh(refresh ? false : true)}
        />
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"ADD NEW PRODUCT"}
          borderRadius={8}
          backgroundColor={colors.secondaryDarkBlue}
          onClick={() => setCreatePostModal(true)}
          width={160}
        />
        <div style={{ minWidth: 10 }} />
      </div>
      {/* catalgue header list view */}
      <div
        style={{
          width: "100%",
          minHeight: 40,
          backgroundColor: colors.secondaryDarkBlue,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ minWidth: 40, maxWidth: 40 }}></div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          <div style={{ marginLeft: 10 }}> Product Name</div>
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          Category
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          Price
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          Created By
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.15,
          }}
        >
          Date Created
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.1,
            // display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
          }}
        >
          Status
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          ACTIONS
        </div>
      </div>
      {/* catalogue list items */}
      <div
        style={{
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          flex: 1,

          borderWidth: 1,
          alignItems: "center",
          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "thin",
        }}
      >
        {productsArray ? (
          productsArray.length >= 1 ? (
            productsArray.map((item, index) => {
              return (
                <div key={index} style={{ width: "100%" }}>
                  <CatalogueListItem
                    productName={item.productName}
                    imageUrl={item.imageId}
                    category={item.category}
                    price={item.price}
                    createdBy={item.createdBy}
                    dateCreated={item.createdOn}
                    onViewClick={() => setSelectedProduct(item)}
                  />
                </div>
              );
            })
          ) : (
            <div>No products have been added yet</div>
          )
        ) : null}
      </div>
      <CreateProductModal
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setLoading={setLoading}
        setToastPop={setToastPop}
        refresh={refresh}
        setRefresh={setRefresh}
        display={createPostModal}
        setCreatePostModal={setCreatePostModal}
        auth={auth}
        companyInformation={companyInformation}
      />
      <CreateProductModal
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setLoading={setLoading}
        setToastPop={setToastPop}
        refresh={refresh}
        setRefresh={setRefresh}
        display={selectedProduct}
        setCreatePostModal={setSelectedProduct}
        auth={auth}
        companyInformation={companyInformation}
        typeCheck={"edit"}
      />
    </div>
  );
};

export default Catalogue;
